import { deleteOtherDeductionItem } from "@/api/other-deduction-items";
import { Button } from "@/components/ui/button";
import {
  OtherDeductionItem,
  OtherDeductionItemType,
  OtherDeductionItemTypeLabels,
} from "@/models/other-deduction-items.model";
import { ColumnDef } from "@tanstack/react-table";

const ActionCell = ({
  row,
  deleteOtherDeductionItemCallback,
}: {
  row: any;
  deleteOtherDeductionItemCallback: (id: number) => void;
}) => {
  const handleDeleteOtherDeductionItem = async () => {
    try {
      const res = await deleteOtherDeductionItem(row.original.id);

      if (res) {
        deleteOtherDeductionItemCallback(row.original.id);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <Button variant="outline" onClick={handleDeleteOtherDeductionItem}>
      Delete
    </Button>
  );
};
export const getOtherDeductionColumns = (
  deleteOtherDeductionItem: (id: number) => void
): ColumnDef<OtherDeductionItem>[] => [
  {
    accessorFn: (row) => row.type,
    cell: ({ row }) => {
      return (
        <span>
          {
            OtherDeductionItemTypeLabels[
              row.original.type as OtherDeductionItemType
            ]
          }
        </span>
      );
    },
    header: "Type",
  },
  {
    accessorFn: (row) => row.amount,
    cell: ({ row }) => {
      return <span>{row.original.amount}</span>;
    },
    header: "Amount ($)",
  },
  {
    header: "Actions",
    cell: ({ row }) => (
      <ActionCell
        deleteOtherDeductionItemCallback={deleteOtherDeductionItem}
        row={row}
      />
    ),
  },
];
